// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import store from './store'
import axios from '../node_modules/axios'
import ElementUI from 'element-ui'
import {getCookie,setCookie,delCookie} from './utils/cookie'
import 'element-ui/lib/theme-chalk/index.css'
import 'swiper/dist/css/swiper.css'
import '@/assets/style/iconfont.css'
import '@/assets/style/common.less'
import '@/assets/style/theme.less'
import Toast from '@/components/toast'
import 'babel-polyfill';
import App from './App'
import router from './router'

Vue.use(ElementUI)
Vue.prototype.$getCookie = getCookie;
Vue.prototype.$setCookie = setCookie;
Vue.prototype.$delCookie = delCookie;
Vue.prototype.$successAlert = function (str){
    this.$message({
        iconClass:'el-icon-circle-check\n',
        center:true,
        customClass:'customize-message-alert',
        message: str
    });
}

Vue.config.productionTip = false
Vue.prototype.$axios = axios;
// Vue.prototype.$toast = Toast.toast;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  axios,
  router,
  components: { App },
  template: '<App/>',
  data: {
    eventHub: new Vue(),
  },

})



// WEBPACK FOOTER //
// ./src/main.js